/* eslint-disable */

export enum AdTemplate {
	Unknown = 0,
	PanoramaTwoThirds = 1,
	Medium = 3,
	Leaderboard = 6,
	LeaderboardLarge = 19,
	PanoramaFull = 7,
	Takeover = 8,
	SmallImageOneThird = 14,
	SmallImageOneForth = 15,
	MediumImageOneThird = 16,
	MediumImageTwoThirds = 17,
	SiteWide = 18,
	PanoramaBrandContent = 21,
	R3Panorama = 22,
	R3FullSize = 23,
	R3HalfSize = 24,
	R3Quarter = 25,
	R3Leaderboard = 26,
	R3PanoramaImage = 27,
	R3CurrentCampaign = 28,
	
}
